export const IApplicationRepositoryType = Symbol('IApplicationRepository');
